// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"71f90c31","455":"102b6241","977":"d17b45fa"}[chunkId] + ".chunk.js";
};